export interface IAuditLogEntry {
  id: number;
  actor_id: number | null;
  actor_name: string | null;
  target_user_id: number | null;
  target_user_name: string | null;
  action: string;
  field: string | null;
  old_value: string | null;
  new_value: string | null;
  ip_address: string | null;
  user_agent: string | null;
  url: string | null;
  created_at: string;
}

export interface IAuditLogResponse {
  data: IAuditLogEntry[];
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}

export class AuditLogEntry {
  private id: number;
  private actorId: number | null;
  private actorName: string | null;
  private targetUserId: number | null;
  private targetUserName: string | null;
  private action: string;
  private field: string | null;
  private oldValue: string | null;
  private newValue: string | null;
  private ipAddress: string | null;
  private userAgent: string | null;
  private url: string | null;
  private createdAt: string;

  get Id(): number { return this.id }
  get ActorId(): number | null { return this.actorId }
  get ActorName(): string | null { return this.actorName }
  get TargetUserId(): number | null { return this.targetUserId }
  get TargetUserName(): string | null { return this.targetUserName }
  get Action(): string { return this.action }
  get Field(): string | null { return this.field }
  get OldValue(): string | null { return this.oldValue }
  get NewValue(): string | null { return this.newValue }
  get IpAddress(): string | null { return this.ipAddress }
  get UserAgent(): string | null { return this.userAgent }
  get Url(): string | null { return this.url }
  get CreatedAt(): string { return this.createdAt }

  constructor(data: IAuditLogEntry) {
    this.id = data.id;
    this.actorId = data.actor_id;
    this.actorName = data.actor_name;
    this.targetUserId = data.target_user_id;
    this.targetUserName = data.target_user_name;
    this.action = data.action;
    this.field = data.field;
    this.oldValue = data.old_value;
    this.newValue = data.new_value;
    this.ipAddress = data.ip_address;
    this.userAgent = data.user_agent;
    this.url = data.url;
    this.createdAt = data.created_at;
  }
}
